import React from 'react';
import {observer} from "mobx-react";
import {PropositionBetsDetailsModuleAsync} from "../../../modules/proposition-bets-details-module/components/proposition-bets-details-module.async";
import {PROPOSITION_BETS} from "../proposition-bets-widgets.consts";
import {APP} from "../../../core/app/consts";

export const PropositionBetsWidgetDetailsPopup = observer(({controller}) => {
  const {state} = controller;
  const {popupDisplay, isVisible} = state;
  const {athleteId, lineTypeId, gameId} = popupDisplay;

  const popupProps = {
    onPopupClose: () => controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick),
    athleteId,
    lineTypeId,
    gameId,
    source: APP.ANALYTICS.SOURCES.propositionBets
  }

  return isVisible ? <PropositionBetsDetailsModuleAsync {...popupProps}/> : null
});
